var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((_vm.officeList),function(item,index){return _c('div',{key:index,staticClass:"office"},[_c('el-image',{staticClass:"officeImg",attrs:{"fit":"fill","src":item,"preview-src-list":_vm.officeList}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }